import ApiClient from './ApiClient';

// GET /api/v1/accounts/:id/voip/units — cor, logo e toque de cada unidade VoIP,
// casados pelo inbox_id da chamada (cadastro em Super Admin > Voip numbers).
class VoipUnitsAPI extends ApiClient {
  constructor() {
    super('voip/units', { accountScoped: true });
  }
}

export default new VoipUnitsAPI();
